/** RESPONSIBILITY: the closing "new here" band on the home page. */
import type { HomeVisitSection } from '@app/sections';

export function HomeVisit({ c }: { c: HomeVisitSection }) {
  return (
    <section className="band band-sand band-centre">
      <div className="wrap">
        {c.eyebrow && <p className="eyebrow">{c.eyebrow}</p>}
        <h2>{c.heading}</h2>
        {c.body && <p className="lede">{c.body}</p>}
        <div className="btns btns-centre">
          {c.ctaLabel && <a className="btn" href={c.ctaHref || '#'}>{c.ctaLabel}</a>}
          {c.altLabel && <a className="btn btn-ghost" href={c.altHref || '#contact'}>{c.altLabel}</a>}
        </div>
      </div>
    </section>
  );
}
